/**
 * Date formatting utilities
 */

/**
 * Converts a Date object to YYYY-MM-DD format without timezone conversion
 * This ensures the date displayed to the user is the date sent to the backend
 * 
 * @param {Date} date - The date object to format
 * @returns {string} Date string in YYYY-MM-DD format (e.g., "2025-12-30")
 * 
 * @example
 * const date = new Date(2025, 11, 30); // Dec 30, 2025
 * formatDateForAPI(date); // Returns: "2025-12-30"
 */
export function formatDateForAPI(date: Date | null | undefined): string | null {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    return null;
  }
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}
 